"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiPayoutStatusEnum = void 0;
var BillingApiPayoutStatusEnum;
(function (BillingApiPayoutStatusEnum) {
  /** В состоянии тренсфера */
  BillingApiPayoutStatusEnum["INPROGRESS"] = "INPROGRESS";
  /** Отменён */
  BillingApiPayoutStatusEnum["CANCELED"] = "CANCELED";
  /** Успешно выплачено */
  BillingApiPayoutStatusEnum["SUCCESS"] = "SUCCESS";
  /** Ошибка (обычно средства возвращаются на баланс) */
  BillingApiPayoutStatusEnum["ERROR"] = "ERROR";
})(BillingApiPayoutStatusEnum = exports.BillingApiPayoutStatusEnum || (exports.BillingApiPayoutStatusEnum = {}));
